// /pages/FleetManagement/Drivers/AddDriverPage.tsx
import React from 'react';
import { Box, Card, CardBody, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { DriverForm } from '@/components/forms/DriverForm';

const AddDriverPage = () => {
    const navigate = useNavigate();

    const handleBack = () => navigate('/fleet-management/drivers');

    return (
        <AdminLayout>
            <Box p={6}>
                <Heading size="lg" mb={2}>Add New Driver</Heading>
                <Text color="gray.600" mb={6}>Register a new driver and assign them to trucks.</Text>
                
                <Card variant="outline">
                    <CardBody>
                        <DriverForm 
                            onSuccess={handleBack} 
                            onCancel={handleBack} 
                        />
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
};

export default AddDriverPage;